import { blocksApiService } from '../../services/blocksApiService'

// One preview fetch per block revision per session, shared by the panel, the library grid and the modal.
const cache = new Map<string, Promise<Blob>>()

export function loadBlockPreview(contentBlockId: string, revision = ''): Promise<Blob> {
  const key = `${contentBlockId}:${revision}`
  let p = cache.get(key)
  if (!p) {
    p = blocksApiService.preview(contentBlockId)
    p.catch(() => cache.delete(key))
    cache.set(key, p)
  }
  return p
}

export function clearBlockPreviewCache(): void {
  cache.clear()
}
